import { render, staticRenderFns } from "./ResourceLink.vue?vue&type=template&id=5a71e8e3"
import script from "./ResourceLink.vue?vue&type=script&lang=js"
export * from "./ResourceLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports